import React from "react";
import { Card } from "react-bootstrap";
import { Navigation, Pagination, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "components/image";
import {
  testimonials, testimonialSlider, testimonialCardContainer,
  testimonialCard, testimonialContent, testimonialTitle,
  testimonialDescription, testimonialImage, tcLink,
  testimonialSlide
} from "./style.mod.scss";
import useResponsiveConfig from "hooks/useResponsiveConfig";
import parsePadding from "helpers/parse-padding";
import TestimonialtsWithoutSlider from "./new-layout";

const Testimonial = ({ data }) => {
  const { title, mobilePadding, tabletPadding, desktopPadding } = data;

  var settings = {
    loop: true,
    spaceBetween: 25,
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    centeredSlides: true,
    autoHeight: true,
    pagination: { clickable: true },
    navigation: { clickable: true },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    modules: [Navigation, Pagination, Mousewheel],
    breakpoints: {
      767: {
        slidesPerView: 1.25,
        spaceBetween: 30,
        pagination: false,
      },
      992: {
        slidesPerView: 1.2,
        spaceBetween: 35,
      },
      1025: {
        spaceBetween: 50,
        slidesPerView: 1.7,
      },
      1270: {
        spaceBetween: 60,
        slidesPerView: 2.3,
      }
    },
  };

  const config = useResponsiveConfig({
    mobile: { styles: parsePadding(mobilePadding) },
    tablet: { styles: parsePadding(tabletPadding) },
    desktop: { styles: parsePadding(desktopPadding) }
  });

  const bgColor = data.bgColor && data.bgColor.hex;


  return data?.testimonialtWithoutSlider ? <TestimonialtsWithoutSlider data={data} /> : (
    <div className={testimonials} style={{
      backgroundColor: bgColor,
      ...config.styles
    }}>
      <Swiper {...settings} className={testimonialSlider}>
        {title.map((tc) => (
          <SwiperSlide key={tc._key} className={testimonialSlide}>
            <div className={testimonialCardContainer} >
              <a className={tcLink} href={tc.link}>
                <Card className={testimonialCard} style={{ backgroundColor: data.testimonialBgColor && data.testimonialBgColor.hex }}>
                  <Card.Body className={testimonialContent} >
                    <Card.Title className={testimonialTitle}>
                      <h6>{tc.title}</h6>
                    </Card.Title>
                    <div className={testimonialImage}>
                      <Image image={tc?.logo} alt={tc.logo?.alt} />
                    </div>
                    <Card.Text className={testimonialDescription}>
                      <span style={{ color: data.textColor && data.textColor.hex }}>{tc.content}</span>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Testimonial;
